module.exports = __webpack_public_path__ + "static/media/Inter.var.feca908d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter.var.woff2
// module id = 713
// module chunks = 21